import { Box, FormControl, Grid, InputLabel, Slider } from '@mui/material'
import { useAppSelector } from 'app/state'
import { RequestStatus } from 'features/common'
import { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { FilterByColumnSettings } from '../../types'
import InputNumber from './InputNumber'

function Between({
  filterSettings,
  onChange
}: {
  filterSettings: FilterByColumnSettings
  onChange: (filterSettings: FilterByColumnSettings) => void
}) {
  const [numberFirst, setNumberFirst] = useState(filterSettings?.filterNumberFirst)
  const [numberSecond, setNumberSecond] = useState(filterSettings?.filterNumberSecond)
  const columnStats = useAppSelector((state) => state.analysis.columnStats)
  const columnStatsStatus = useAppSelector((state) => state.analysis.columnStatsStatus)
  const max = columnStats?.max
  const min = columnStats?.min
  const isDisabled = (!min && !max) || columnStatsStatus === RequestStatus.Idle

  useEffect(() => {
    if (columnStatsStatus === RequestStatus.Fulfilled && columnStats) {
      const { min, max } = columnStats
      if ((numberFirst !== undefined && numberFirst < min) || numberFirst === undefined) {
        setNumberFirst(min)
      }
      if ((numberSecond !== undefined && numberSecond > max) || numberSecond === undefined) {
        setNumberSecond(max)
      }
    }
  }, [columnStats, numberFirst, numberSecond, columnStatsStatus])

  const handleChange = (e, newValue) => {
    setNumberFirst(newValue[0])
    setNumberSecond(newValue[1])
    const newState = { ...filterSettings, filterNumberFirst: newValue[0], filterNumberSecond: newValue[1] }
    onChange(newState)
  }

  return (
    <FormControl size="small" margin="normal">
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <InputLabel id={`analysis-numbers-slide-label`} variant="outlined">
            <FormattedMessage id="analysis.columnValue.numberFilter.input.slide" />
          </InputLabel>
          <Box ml={1} mr={0.5}>
            <Slider
              min={min}
              max={max}
              name="analysis-numbers-slide-label"
              disabled={isDisabled}
              value={[numberFirst || 0, numberSecond || 100]}
              onChange={handleChange}
            />
          </Box>
        </Grid>
        <Grid container spacing={1} justifyContent="space-between" ml={0.5}>
          <Grid item xs={4}>
            <InputNumber
              number={numberFirst}
              disabled={isDisabled}
              adornment="≥"
              onChange={(value) => {
                setNumberFirst(value)
                onChange({ ...filterSettings, filterNumberFirst: value })
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <InputNumber
              number={numberSecond}
              disabled={isDisabled}
              adornment="≤"
              onChange={(value) => {
                setNumberSecond(value)
                onChange({ ...filterSettings, filterNumberSecond: value })
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </FormControl>
  )
}

export default Between
